module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7VuGv"))).then(() => parcelRequire('1iHdE'));